import { ChangeEvent, useState } from 'react';

type FormFieldEvent = ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>;
interface FormFieldInput {
  target: {
    id: string;
    value: unknown;
  };
}

export const useFormFields = <T extends Record<string, unknown>>(
  initialState: T
): readonly [T, (event: FormFieldEvent | FormFieldInput) => void] => {
  const [fields, setValues] = useState<T>(initialState);

  const handleFieldChange = (event: FormFieldEvent | FormFieldInput): void => {
    setValues(
      (prev) =>
        ({
          ...prev,
          [event.target.id]: event.target.value
        }) as T
    );
  };

  return [fields, handleFieldChange] as const;
};
